import { ProductCategory } from '../types/product.types';

export interface SiteCategory extends ProductCategory {
  icon: string;
  path: string;
  description: string;
  featuredSubcategories?: Array<{ name: string; slug: string; path: string; icon: string }>;
  quickLinks?: Array<{ label: string; path: string }>;
}

const buildPath = (slug: string, parentSlug?: string) =>
  parentSlug ? `/${parentSlug}/${slug}` : `/${slug}`;

export const CATEGORY_TREE: SiteCategory[] = [
  {
    id: 'it-networking',
    name: 'IT & Networking',
    slug: 'it-networking',
    path: buildPath('it-networking'),
    icon: 'globe',
    description: 'Enterprise-grade wired and wireless network infrastructure for offices, campuses, and data centers.',
    productCount: 520,
    children: [
      { id: 'wifi-routers-access-points', name: 'WiFi Routers & Access Points', slug: 'wifi-routers-access-points', path: buildPath('wifi-routers-access-points', 'it-networking'), icon: 'wifi', productCount: 140 },
      { id: 'network-switches', name: 'Network Switches', slug: 'network-switches', path: buildPath('network-switches', 'it-networking'), icon: 'plug', productCount: 98 },
      { id: 'media-converters', name: 'Media Converters', slug: 'media-converters', path: buildPath('media-converters', 'it-networking'), icon: 'wrench', productCount: 65 },
      { id: 'cables-connectors', name: 'Cables & Connectors', slug: 'cables-connectors', path: buildPath('cables-connectors', 'it-networking'), icon: 'cables', productCount: 217 }
    ],
    featuredSubcategories: [
      { name: 'WiFi Routers & Access Points', slug: 'wifi-routers-access-points', path: buildPath('wifi-routers-access-points', 'it-networking'), icon: 'wifi' },
      { name: 'Network Switches', slug: 'network-switches', path: buildPath('network-switches', 'it-networking'), icon: 'plug' },
      { name: 'Cables & Connectors', slug: 'cables-connectors', path: buildPath('cables-connectors', 'it-networking'), icon: 'cables' }
    ],
    quickLinks: [
      { label: 'Request Network Quote', path: '/contact' },
      { label: 'Bulk Order Support', path: '/account/rfqs' }
    ]
  },
  {
    id: 'security-systems',
    name: 'Security Systems',
    slug: 'security-systems',
    path: buildPath('security-systems'),
    icon: 'shield',
    description: 'Complete CCTV, access control, and surveillance systems for enterprise and industrial applications.',
    productCount: 990,
    children: [
      { id: 'cctv-cameras', name: 'CCTV Cameras', slug: 'cctv-cameras', path: buildPath('cctv-cameras', 'security-systems'), icon: 'camera', productCount: 219 },
      { id: 'ip-cameras', name: 'IP Cameras', slug: 'ip-cameras', path: buildPath('ip-cameras', 'security-systems'), icon: 'video', productCount: 176 },
      { id: 'smart-wifi-cameras', name: 'Smart WiFi Cameras', slug: 'smart-wifi-cameras', path: buildPath('smart-wifi-cameras', 'security-systems'), icon: 'wireless', productCount: 112 },
      { id: 'dome-cameras', name: 'Dome Cameras', slug: 'dome-cameras', path: buildPath('dome-cameras', 'security-systems'), icon: 'dome', productCount: 95 },
      { id: 'bullet-cameras', name: 'Bullet Cameras', slug: 'bullet-cameras', path: buildPath('bullet-cameras', 'security-systems'), icon: 'bullet', productCount: 120 },
      { id: 'spy-cameras', name: 'Spy Cameras', slug: 'spy-cameras', path: buildPath('spy-cameras', 'security-systems'), icon: 'spy', productCount: 33 },
      { id: 'cctv-combo-kits', name: 'CCTV Combo Kits', slug: 'cctv-combo-kits', path: buildPath('cctv-combo-kits', 'security-systems'), icon: 'gift', productCount: 58 },
      { id: 'cctv-accessories', name: 'CCTV Accessories', slug: 'cctv-accessories', path: buildPath('cctv-accessories', 'security-systems'), icon: 'accessories', productCount: 204 },
      { id: 'solar-cctv-cameras', name: 'Solar CCTV Cameras', slug: 'solar-cctv-cameras', path: buildPath('solar-cctv-cameras', 'security-systems'), icon: 'sun', productCount: 27 },
      { id: 'access-control', name: 'Access Control', slug: 'access-control', path: buildPath('access-control', 'security-systems'), icon: 'lock', productCount: 137 },
      { id: 'biometric-systems', name: 'Biometric Systems', slug: 'biometric-systems', path: buildPath('biometric-systems', 'security-systems'), icon: 'biometric', productCount: 97 },
      { id: 'door-access-control', name: 'Door Access Control', slug: 'door-access-control', path: buildPath('door-access-control', 'security-systems'), icon: 'door', productCount: 102 },
      { id: 'smart-door-locks', name: 'Smart Door Locks', slug: 'smart-door-locks', path: buildPath('smart-door-locks', 'security-systems'), icon: 'unlock', productCount: 97 },
      { id: 'video-door-phones', name: 'Video Door Phones', slug: 'video-door-phones', path: buildPath('video-door-phones', 'security-systems'), icon: 'phone', productCount: 57 },
      { id: 'metal-detectors', name: 'Metal Detectors', slug: 'metal-detectors', path: buildPath('metal-detectors', 'security-systems'), icon: 'search', productCount: 24 }
    ],
    featuredSubcategories: [
      { name: 'CCTV Cameras', slug: 'cctv-cameras', path: buildPath('cctv-cameras', 'security-systems'), icon: 'camera' },
      { name: 'Smart Door Locks', slug: 'smart-door-locks', path: buildPath('smart-door-locks', 'security-systems'), icon: 'unlock' },
      { name: 'Access Control', slug: 'access-control', path: buildPath('access-control', 'security-systems'), icon: 'lock' }
    ],
    quickLinks: [
      { label: 'CCTV Installation & AMC', path: '/contact' },
      { label: 'Security Assessment', path: '/contact' }
    ]
  },
  {
    id: 'communication-systems',
    name: 'Communication Systems',
    slug: 'communication-systems',
    path: buildPath('communication-systems'),
    icon: 'wireless',
    description: 'Conference, intercom, and enterprise telephony systems built for clear communication.',
    productCount: 258,
    children: [
      { id: 'conference-phones', name: 'Conference Phones', slug: 'conference-phones', path: buildPath('conference-phones', 'communication-systems'), icon: 'phone', productCount: 62 },
      { id: 'intercom-systems', name: 'Intercom Systems', slug: 'intercom-systems', path: buildPath('intercom-systems', 'communication-systems'), icon: 'smartphone', productCount: 72 },
      { id: 'landline-phones', name: 'Landline Phones', slug: 'landline-phones', path: buildPath('landline-phones', 'communication-systems'), icon: 'phone', productCount: 96 },
      { id: 'epabx-systems', name: 'EPABX Systems', slug: 'epabx-systems', path: buildPath('epabx-systems', 'communication-systems'), icon: 'epabx', productCount: 28 }
    ],
    featuredSubcategories: [
      { name: 'Conference Phones', slug: 'conference-phones', path: buildPath('conference-phones', 'communication-systems'), icon: 'phone' },
      { name: 'Intercom Systems', slug: 'intercom-systems', path: buildPath('intercom-systems', 'communication-systems'), icon: 'smartphone' }
    ],
    quickLinks: [
      { label: 'Office Intercom Quote', path: '/contact' },
      { label: 'Meeting Room Setup', path: '/contact' }
    ]
  },
  {
    id: 'lighting-solutions',
    name: 'Lighting Solutions',
    slug: 'lighting-solutions',
    path: buildPath('lighting-solutions'),
    icon: 'lightbulb',
    description: 'Architectural, industrial, and smart lighting systems for interiors and exteriors.',
    productCount: 760,
    children: [
      { id: 'downlights', name: 'Downlights', slug: 'downlights', path: buildPath('downlights', 'lighting-solutions'), icon: 'flashlight', productCount: 120 },
      { id: 'strip-lights', name: 'Strip Lights', slug: 'strip-lights', path: buildPath('strip-lights', 'lighting-solutions'), icon: 'ruler', productCount: 98 },
      { id: 'track-lights', name: 'Track Lights', slug: 'track-lights', path: buildPath('track-lights', 'lighting-solutions'), icon: 'compass', productCount: 74 },
      { id: 'outdoor-lights', name: 'Outdoor Lights', slug: 'outdoor-lights', path: buildPath('outdoor-lights', 'lighting-solutions'), icon: 'moon', productCount: 112 },
      { id: 'garden-lights', name: 'Garden Lights', slug: 'garden-lights', path: buildPath('garden-lights', 'lighting-solutions'), icon: 'leaf', productCount: 86 },
      { id: 'sensor-lights', name: 'Sensor Lights', slug: 'sensor-lights', path: buildPath('sensor-lights', 'lighting-solutions'), icon: 'sensor', productCount: 48 },
      { id: 'presence-sensors', name: 'Presence Sensors', slug: 'presence-sensors', path: buildPath('presence-sensors', 'lighting-solutions'), icon: 'activity', productCount: 33 },
      { id: 'lighting-drivers', name: 'Lighting Drivers', slug: 'lighting-drivers', path: buildPath('lighting-drivers', 'lighting-solutions'), icon: 'settings', productCount: 54 },
      { id: 'phase-cut-dimmable-drivers', name: 'Phase-Cut Dimmable Drivers', slug: 'phase-cut-dimmable-drivers', path: buildPath('phase-cut-dimmable-drivers', 'lighting-solutions'), icon: 'contrast', productCount: 19 },
      { id: 'dali-drivers', name: 'DALI Drivers', slug: 'dali-drivers', path: buildPath('dali-drivers', 'lighting-solutions'), icon: 'sliders', productCount: 16 },
      { id: 'on-off-drivers', name: 'On/Off Drivers', slug: 'on-off-drivers', path: buildPath('on-off-drivers', 'lighting-solutions'), icon: '⏯', productCount: 21 },
      { id: 'strip-light-drivers', name: 'Strip Light Drivers', slug: 'strip-light-drivers', path: buildPath('strip-light-drivers', 'lighting-solutions'), icon: 'cpu', productCount: 22 }
    ],
    featuredSubcategories: [
      { name: 'Downlights', slug: 'downlights', path: buildPath('downlights', 'lighting-solutions'), icon: 'flashlight' },
      { name: 'Strip Lights', slug: 'strip-lights', path: buildPath('strip-lights', 'lighting-solutions'), icon: 'ruler' },
      { name: 'Lighting Drivers', slug: 'lighting-drivers', path: buildPath('lighting-drivers', 'lighting-solutions'), icon: 'settings' }
    ],
    quickLinks: [
      { label: 'Lighting Design Support', path: '/contact' },
      { label: 'DALI Consultation', path: '/contact' }
    ]
  },
  {
    id: 'electricals',
    name: 'Electricals',
    slug: 'electricals',
    path: buildPath('electricals'),
    icon: 'lightning',
    description: 'Electrical fixtures, switchgear, power supplies, and industrial wiring solutions for smart buildings.',
    productCount: 680,
    children: [
      { id: 'wiring-accessories', name: 'Wiring Accessories', slug: 'wiring-accessories', path: buildPath('wiring-accessories', 'electricals'), icon: 'screw', productCount: 142 },
      { id: 'switches-sockets', name: 'Switches & Sockets', slug: 'switches-sockets', path: buildPath('switches-sockets', 'electricals'), icon: 'button', productCount: 164 },
      { id: 'electrical-components', name: 'Electrical Components', slug: 'electrical-components', path: buildPath('electrical-components', 'electricals'), icon: 'pin', productCount: 201 },
      { id: 'power-supplies', name: 'Power Supplies', slug: 'power-supplies', path: buildPath('power-supplies', 'electricals'), icon: 'battery', productCount: 83 },
      { id: 'smps-power-supplies', name: 'SMPS / Power Supplies', slug: 'smps-power-supplies', path: buildPath('smps-power-supplies', 'electricals'), icon: 'settings', productCount: 90 }
    ],
    featuredSubcategories: [
      { name: 'Power Supplies', slug: 'power-supplies', path: buildPath('power-supplies', 'electricals'), icon: 'battery' },
      { name: 'Switches & Sockets', slug: 'switches-sockets', path: buildPath('switches-sockets', 'electricals'), icon: 'button' },
      { name: 'SMPS / Power Supplies', slug: 'smps-power-supplies', path: buildPath('smps-power-supplies', 'electricals'), icon: 'settings' }
    ],
    quickLinks: [
      { label: 'Electrical AMC', path: '/contact' },
      { label: 'Power Audit', path: '/contact' }
    ]
  },
  {
    id: 'home-automation',
    name: 'Home Automation',
    slug: 'home-automation',
    path: buildPath('home-automation'),
    icon: 'home',
    description: 'End-to-end smart home automation solutions for lighting, curtains, climate, and media control.',
    productCount: 540,
    children: [
      { id: 'smart-lighting-automation', name: 'Smart Lighting Automation', slug: 'smart-lighting-automation', path: buildPath('smart-lighting-automation', 'home-automation'), icon: 'lightbulb', productCount: 132 },
      { id: 'smart-curtains', name: 'Smart Curtains', slug: 'smart-curtains', path: buildPath('smart-curtains', 'home-automation'), icon: 'window', productCount: 87 },
      { id: 'smart-fans', name: 'Smart Fans', slug: 'smart-fans', path: buildPath('smart-fans', 'home-automation'), icon: 'fan', productCount: 78 },
      { id: 'smart-ac-control', name: 'Smart AC Control', slug: 'smart-ac-control', path: buildPath('smart-ac-control', 'home-automation'), icon: 'snow', productCount: 68 },
      { id: 'audio-video-automation', name: 'Audio/Video Automation', slug: 'audio-video-automation', path: buildPath('audio-video-automation', 'home-automation'), icon: 'knob', productCount: 95 }
    ],
    featuredSubcategories: [
      { name: 'Smart Lighting Automation', slug: 'smart-lighting-automation', path: buildPath('smart-lighting-automation', 'home-automation'), icon: 'lightbulb' },
      { name: 'Smart Curtains', slug: 'smart-curtains', path: buildPath('smart-curtains', 'home-automation'), icon: 'window' },
      { name: 'Smart AC Control', slug: 'smart-ac-control', path: buildPath('smart-ac-control', 'home-automation'), icon: 'snow' }
    ],
    quickLinks: [
      { label: 'Home Automation Quote', path: '/contact' },
      { label: 'Installation & AMC', path: '/contact' }
    ]
  },
  {
    id: 'audio-video',
    name: 'Audio & Video',
    slug: 'audio-video',
    path: buildPath('audio-video'),
    icon: 'headphones',
    description: 'Pro AV solutions for conference rooms, auditoriums, digital signage, and streaming environments.',
    productCount: 448,
    children: [
      { id: 'av-equipment', name: 'AV Equipment', slug: 'av-equipment', path: buildPath('av-equipment', 'audio-video'), icon: 'sliders', productCount: 68 },
      { id: 'amplifiers', name: 'Amplifiers', slug: 'amplifiers', path: buildPath('amplifiers', 'audio-video'), icon: 'speaker', productCount: 56 },
      { id: 'projectors', name: 'Projectors', slug: 'projectors', path: buildPath('projectors', 'audio-video'), icon: 'projector', productCount: 79 },
      { id: 'speakers', name: 'Speakers', slug: 'speakers', path: buildPath('speakers', 'audio-video'), icon: 'speaker', productCount: 84 },
      { id: 'motorized-screens', name: 'Motorized Screens', slug: 'motorized-screens', path: buildPath('motorized-screens', 'audio-video'), icon: 'monitor', productCount: 31 },
      { id: 'fixed-screens', name: 'Fixed Screens', slug: 'fixed-screens', path: buildPath('fixed-screens', 'audio-video'), icon: 'image', productCount: 25 },
      { id: 'video-walls', name: 'Video Walls', slug: 'video-walls', path: buildPath('video-walls', 'audio-video'), icon: 'brick', productCount: 19 },
      { id: 'av-accessories', name: 'AV Accessories', slug: 'av-accessories', path: buildPath('av-accessories', 'audio-video'), icon: 'knob', productCount: 73 },
      { id: 'rca-cables', name: 'RCA Cables', slug: 'rca-cables', path: buildPath('rca-cables', 'audio-video'), icon: 'plug', productCount: 24 },
      { id: 'hdmi-cables', name: 'HDMI Cables', slug: 'hdmi-cables', path: buildPath('hdmi-cables', 'audio-video'), icon: 'link', productCount: 39 },
      { id: 'aux-cables', name: 'AUX Cables', slug: 'aux-cables', path: buildPath('aux-cables', 'audio-video'), icon: 'headphones', productCount: 22 },
      { id: 'optical-toslink-cables', name: 'Optical/TOSLINK Cables', slug: 'optical-toslink-cables', path: buildPath('optical-toslink-cables', 'audio-video'), icon: 'lightbulb', productCount: 14 },
      { id: 'wireless-microphones', name: 'Wireless Microphones', slug: 'wireless-microphones', path: buildPath('wireless-microphones', 'audio-video'), icon: 'mic', productCount: 29 },
      { id: 'usb-condenser-microphones', name: 'USB Condenser Microphones', slug: 'usb-condenser-microphones', path: buildPath('usb-condenser-microphones', 'audio-video'), icon: 'studioMic', productCount: 21 },
      { id: 'dac-converters', name: 'DAC Converters', slug: 'dac-converters', path: buildPath('dac-converters', 'audio-video'), icon: 'speaker', productCount: 12 },
      { id: 'audio-splitters-mixers', name: 'Audio Splitters & Mixers', slug: 'audio-splitters-mixers', path: buildPath('audio-splitters-mixers', 'audio-video'), icon: 'knob', productCount: 33 },
      { id: 'capture-cards', name: 'Capture Cards', slug: 'capture-cards', path: buildPath('capture-cards', 'audio-video'), icon: 'clapper', productCount: 18 },
      { id: 'av-to-hdmi-converters', name: 'AV to HDMI Converters', slug: 'av-to-hdmi-converters', path: buildPath('av-to-hdmi-converters', 'audio-video'), icon: 'loop', productCount: 13 },
      { id: 'video-switchers', name: 'Video Switchers', slug: 'video-switchers', path: buildPath('video-switchers', 'audio-video'), icon: 'sliders', productCount: 20 },
      { id: 'tripods', name: 'Tripods', slug: 'tripods', path: buildPath('tripods', 'audio-video'), icon: 'camera', productCount: 39 },
      { id: 'streaming-accessories', name: 'Streaming Accessories', slug: 'streaming-accessories', path: buildPath('streaming-accessories', 'audio-video'), icon: 'video', productCount: 46 }
    ],
    featuredSubcategories: [
      { name: 'Projectors', slug: 'projectors', path: buildPath('projectors', 'audio-video'), icon: 'projector' },
      { name: 'Speakers', slug: 'speakers', path: buildPath('speakers', 'audio-video'), icon: 'speaker' },
      { name: 'Wireless Microphones', slug: 'wireless-microphones', path: buildPath('wireless-microphones', 'audio-video'), icon: 'mic' }
    ],
    quickLinks: [
      { label: 'AV Consultation', path: '/contact' },
      { label: 'Streaming Setup', path: '/contact' }
    ]
  },
  {
    id: 'computers-accessories',
    name: 'Computers & Accessories',
    slug: 'computers-accessories',
    path: buildPath('computers-accessories'),
    icon: 'laptop',
    description: 'Business computing and peripherals for office, meeting rooms, and IT infrastructure.',
    productCount: 350,
    children: [
      { id: 'computer-mouse', name: 'Computer Mouse', slug: 'computer-mouse', path: buildPath('computer-mouse', 'computers-accessories'), icon: 'mouse', productCount: 150 },
      { id: 'keyboards', name: 'Keyboards', slug: 'keyboards', path: buildPath('keyboards', 'computers-accessories'), icon: 'keyboard', productCount: 120 },
      { id: 'led-monitors', name: 'LED Monitors', slug: 'led-monitors', path: buildPath('led-monitors', 'computers-accessories'), icon: 'monitor', productCount: 95 },
      { id: 'tablets', name: 'Tablets', slug: 'tablets', path: buildPath('tablets', 'computers-accessories'), icon: 'tablet', productCount: 68 },
      { id: 'usb-hubs', name: 'USB Hubs', slug: 'usb-hubs', path: buildPath('usb-hubs', 'computers-accessories'), icon: 'link', productCount: 54 },
      { id: 'desktops', name: 'Desktops', slug: 'desktops', path: buildPath('desktops', 'computers-accessories'), icon: 'monitor', productCount: 48 },
      { id: 'network-interface-cards', name: 'Network Interface Cards', slug: 'network-interface-cards', path: buildPath('network-interface-cards', 'computers-accessories'), icon: 'wireless', productCount: 31 }
    ],
    featuredSubcategories: [
      { name: 'LED Monitors', slug: 'led-monitors', path: buildPath('led-monitors', 'computers-accessories'), icon: 'monitor' },
      { name: 'Keyboards', slug: 'keyboards', path: buildPath('keyboards', 'computers-accessories'), icon: 'keyboard' },
      { name: 'USB Hubs', slug: 'usb-hubs', path: buildPath('usb-hubs', 'computers-accessories'), icon: 'link' }
    ],
    quickLinks: [
      { label: 'Bulk Computer Procurement', path: '/contact' },
      { label: 'IT Deployment Service', path: '/contact' }
    ]
  },
  {
    id: 'office-supplies',
    name: 'Office Supplies',
    slug: 'office-supplies',
    path: buildPath('office-supplies'),
    icon: 'folder',
    description: 'Essential office supplies, stationery, desk accessories, and workplace hygiene solutions.',
    productCount: 190,
    children: [
      { id: 'office-essentials', name: 'Office Essentials', slug: 'office-essentials', path: buildPath('office-essentials', 'office-supplies'), icon: 'receipt', productCount: 90 },
      { id: 'stationery', name: 'Stationery', slug: 'stationery', path: buildPath('stationery', 'office-supplies'), icon: 'pencil', productCount: 68 },
      { id: 'desk-accessories', name: 'Desk Accessories', slug: 'desk-accessories', path: buildPath('desk-accessories', 'office-supplies'), icon: 'cabinet', productCount: 32 }
    ],
    featuredSubcategories: [
      { name: 'Office Essentials', slug: 'office-essentials', path: buildPath('office-essentials', 'office-supplies'), icon: 'receipt' },
      { name: 'Stationery', slug: 'stationery', path: buildPath('stationery', 'office-supplies'), icon: 'pencil' },
      { name: 'Desk Accessories', slug: 'desk-accessories', path: buildPath('desk-accessories', 'office-supplies'), icon: 'cabinet' }
    ],
    quickLinks: [
      { label: 'Procurement Support', path: '/contact' },
      { label: 'Office Bundles', path: '/contact' }
    ]
  },
  {
    id: 'safety-products',
    name: 'Safety Products',
    slug: 'safety-products',
    path: buildPath('safety-products'),
    icon: 'vest',
    description: 'Protective equipment and safety essentials for industrial, construction, and workplace environments.',
    productCount: 210,
    children: [
      { id: 'safety-shoes', name: 'Safety Shoes', slug: 'safety-shoes', path: buildPath('safety-shoes', 'safety-products'), icon: 'shoe', productCount: 76 },
      { id: 'safety-gloves', name: 'Safety Gloves', slug: 'safety-gloves', path: buildPath('safety-gloves', 'safety-products'), icon: 'glove', productCount: 71 },
      { id: 'surgical-gloves', name: 'Surgical Gloves', slug: 'surgical-gloves', path: buildPath('surgical-gloves', 'safety-products'), icon: 'stethoscope', productCount: 32 },
      { id: 'safety-jackets', name: 'Safety Jackets', slug: 'safety-jackets', path: buildPath('safety-jackets', 'safety-products'), icon: 'coat', productCount: 18 },
      { id: 'safety-helmets', name: 'Safety Helmets', slug: 'safety-helmets', path: buildPath('safety-helmets', 'safety-products'), icon: 'helmet', productCount: 23 }
    ],
    featuredSubcategories: [
      { name: 'Safety Shoes', slug: 'safety-shoes', path: buildPath('safety-shoes', 'safety-products'), icon: 'shoe' },
      { name: 'Safety Gloves', slug: 'safety-gloves', path: buildPath('safety-gloves', 'safety-products'), icon: 'glove' },
      { name: 'Safety Helmets', slug: 'safety-helmets', path: buildPath('safety-helmets', 'safety-products'), icon: 'helmet' }
    ],
    quickLinks: [
      { label: 'Safety Training Request', path: '/contact' },
      { label: 'Bulk PPE Quote', path: '/contact' }
    ]
  },
  {
    id: 'hydraulic-pneumatic',
    name: 'Hydraulic & Pneumatic',
    slug: 'hydraulic-pneumatic',
    path: buildPath('hydraulic-pneumatic'),
    icon: 'wrench',
    description: 'Industrial hydraulic and pneumatic components including cylinders, valves, fittings, compressors, and fluid power systems.',
    productCount: 480,
    children: [
      { id: 'hydraulic-cylinders', name: 'Hydraulic Cylinders', slug: 'hydraulic-cylinders', path: buildPath('hydraulic-cylinders', 'hydraulic-pneumatic'), icon: 'barrel', productCount: 92 },
      { id: 'hydraulic-pumps', name: 'Hydraulic Pumps', slug: 'hydraulic-pumps', path: buildPath('hydraulic-pumps', 'hydraulic-pneumatic'), icon: 'settings', productCount: 74 },
      { id: 'hydraulic-valves', name: 'Hydraulic Valves', slug: 'hydraulic-valves', path: buildPath('hydraulic-valves', 'hydraulic-pneumatic'), icon: 'screw', productCount: 68 },
      { id: 'hydraulic-hoses-fittings', name: 'Hydraulic Hoses & Fittings', slug: 'hydraulic-hoses-fittings', path: buildPath('hydraulic-hoses-fittings', 'hydraulic-pneumatic'), icon: 'cables', productCount: 85 },
      { id: 'pneumatic-cylinders', name: 'Pneumatic Cylinders', slug: 'pneumatic-cylinders', path: buildPath('pneumatic-cylinders', 'hydraulic-pneumatic'), icon: 'factory', productCount: 56 },
      { id: 'air-compressors', name: 'Air Compressors', slug: 'air-compressors', path: buildPath('air-compressors', 'hydraulic-pneumatic'), icon: 'wind', productCount: 48 },
      { id: 'pneumatic-valves', name: 'Pneumatic Valves', slug: 'pneumatic-valves', path: buildPath('pneumatic-valves', 'hydraulic-pneumatic'), icon: 'wrench', productCount: 57 }
    ],
    featuredSubcategories: [
      { name: 'Hydraulic Cylinders', slug: 'hydraulic-cylinders', path: buildPath('hydraulic-cylinders', 'hydraulic-pneumatic'), icon: 'barrel' },
      { name: 'Air Compressors', slug: 'air-compressors', path: buildPath('air-compressors', 'hydraulic-pneumatic'), icon: 'wind' },
      { name: 'Hydraulic Valves', slug: 'hydraulic-valves', path: buildPath('hydraulic-valves', 'hydraulic-pneumatic'), icon: 'screw' }
    ],
    quickLinks: [
      { label: 'Hydraulic System Quote', path: '/contact' },
      { label: 'Bulk Pneumatic Order', path: '/account/rfqs' }
    ]
  },
  {
    id: 'hardware',
    name: 'Hardware',
    slug: 'hardware',
    path: buildPath('hardware'),
    icon: 'hammer',
    description: 'Industrial and construction hardware including fasteners, bolts, nuts, anchors, brackets, hinges, and structural fittings.',
    productCount: 620,
    children: [
      { id: 'fasteners', name: 'Fasteners', slug: 'fasteners', path: buildPath('fasteners', 'hardware'), icon: 'screw', productCount: 145 },
      { id: 'bolts-nuts', name: 'Bolts & Nuts', slug: 'bolts-nuts', path: buildPath('bolts-nuts', 'hardware'), icon: 'settings', productCount: 118 },
      { id: 'screws', name: 'Screws', slug: 'screws', path: buildPath('screws', 'hardware'), icon: 'wrench', productCount: 96 },
      { id: 'anchors-wall-plugs', name: 'Anchors & Wall Plugs', slug: 'anchors-wall-plugs', path: buildPath('anchors-wall-plugs', 'hardware'), icon: 'brick', productCount: 72 },
      { id: 'hinges-brackets', name: 'Hinges & Brackets', slug: 'hinges-brackets', path: buildPath('hinges-brackets', 'hardware'), icon: 'door', productCount: 88 },
      { id: 'locks-latches', name: 'Locks & Latches', slug: 'locks-latches', path: buildPath('locks-latches', 'hardware'), icon: 'lock', productCount: 64 },
      { id: 'structural-fittings', name: 'Structural Fittings', slug: 'structural-fittings', path: buildPath('structural-fittings', 'hardware'), icon: 'construction', productCount: 37 }
    ],
    featuredSubcategories: [
      { name: 'Fasteners', slug: 'fasteners', path: buildPath('fasteners', 'hardware'), icon: 'screw' },
      { name: 'Bolts & Nuts', slug: 'bolts-nuts', path: buildPath('bolts-nuts', 'hardware'), icon: 'settings' },
      { name: 'Hinges & Brackets', slug: 'hinges-brackets', path: buildPath('hinges-brackets', 'hardware'), icon: 'door' }
    ],
    quickLinks: [
      { label: 'Bulk Hardware Quote', path: '/contact' },
      { label: 'Fastener Procurement', path: '/account/rfqs' }
    ]
  },
  {
    id: 'services-support',
    name: 'Services & Support',
    slug: 'services-support',
    path: buildPath('services-support'),
    icon: 'bell',
    description: 'Installation, AMC, system commissioning, and business support services for B2B buyers.',
    productCount: 92,
    children: [
      { id: 'installation', name: 'Installation', slug: 'installation', path: buildPath('installation', 'services-support'), icon: 'wrench', productCount: 24 },
      { id: 'amc', name: 'AMC', slug: 'amc', path: buildPath('amc', 'services-support'), icon: 'wrench', productCount: 31 },
      { id: 'cctv-installation-amc', name: 'CCTV Installation & AMC', slug: 'cctv-installation-amc', path: buildPath('cctv-installation-amc', 'services-support'), icon: 'cctv', productCount: 18 },
      { id: 'home-automation-solutions', name: 'Home Automation Solutions', slug: 'home-automation-solutions', path: buildPath('home-automation-solutions', 'services-support'), icon: 'home', productCount: 12 },
      { id: 'audio-video-solutions', name: 'Audio-Video Solutions', slug: 'audio-video-solutions', path: buildPath('audio-video-solutions', 'services-support'), icon: 'clapper', productCount: 7 }
    ],
    featuredSubcategories: [
      { name: 'Installation', slug: 'installation', path: buildPath('installation', 'services-support'), icon: 'wrench' },
      { name: 'AMC', slug: 'amc', path: buildPath('amc', 'services-support'), icon: 'wrench' },
      { name: 'CCTV Installation & AMC', slug: 'cctv-installation-amc', path: buildPath('cctv-installation-amc', 'services-support'), icon: 'cctv' }
    ],
    quickLinks: [
      { label: 'Request Service Proposal', path: '/contact' },
      { label: 'RFQ Support', path: '/account/rfqs' }
    ]
  }
];

if (typeof window !== 'undefined') {
  try {
    const deletedIds = JSON.parse(localStorage.getItem('categories_db_deleted_ids') || '[]');
    if (deletedIds.length > 0) {
      const deletedSet = new Set(deletedIds);
      const activeCats = CATEGORY_TREE.filter(c => !deletedSet.has(c.id));
      CATEGORY_TREE.length = 0;
      CATEGORY_TREE.push(...activeCats);
      
      CATEGORY_TREE.forEach(c => {
        if (c.children) {
          c.children = c.children.filter(s => !deletedSet.has(`${c.id}/${s.id}`) && !deletedSet.has(s.id));
        }
      });
    }

    const saved = localStorage.getItem('categories_db_custom');
    if (saved) {
      const customCats = JSON.parse(saved);
      customCats.forEach((customCat: any) => {
        const existingCat = CATEGORY_TREE.find(
          (c) => c.name.toLowerCase() === customCat.name.toLowerCase() || c.id === customCat.id
        );
        if (existingCat) {
          if (customCat.children) {
            customCat.children.forEach((customSub: any) => {
              const existingSub = existingCat.children?.find(
                (s) => s.name.toLowerCase() === customSub.name.toLowerCase() || s.id === customSub.id
              );
              if (!existingSub) {
                if (!existingCat.children) existingCat.children = [];
                existingCat.children.push(customSub);
              }
            });
          }
        } else {
          CATEGORY_TREE.push(customCat);
        }
      });
    }

    const editedCats = JSON.parse(localStorage.getItem('categories_db_edited') || '[]');
    if (editedCats.length > 0) {
      editedCats.forEach((editedCat: any) => {
        const idx = CATEGORY_TREE.findIndex(c => c.id === editedCat.id);
        if (idx !== -1) {
          CATEGORY_TREE[idx] = { ...CATEGORY_TREE[idx], ...editedCat };
        }
      });
    }
  } catch (e) {
    console.error("Failed to seed custom categories", e);
  }
}

const topCategoryMap: Record<string, SiteCategory> = {};
const subCategoryMap: Record<string, ProductCategory> = {};

CATEGORY_TREE.forEach((category) => {
  topCategoryMap[category.slug] = category;
  category.children?.forEach((child) => {
    subCategoryMap[`${category.slug}/${child.slug}`] = child;
  });
});

export const getCategoryBySlug = (slug: string | undefined) =>
  slug ? topCategoryMap[slug] : undefined;

export const getSubCategoryBySlug = (parentSlug: string | undefined, slug: string | undefined) =>
  parentSlug && slug ? subCategoryMap[`${parentSlug}/${slug}`] : undefined;

export const CATEGORY_SUGGESTIONS = CATEGORY_TREE.flatMap((category) => [
  { label: category.name, path: category.path },
  ...(category.children || []).slice(0, 3).map((child) => ({ label: child.name, path: child.path }))
]);

export const POPULAR_SEARCHES = [
  'WiFi Routers',
  'CCTV Cameras',
  'Smart Door Locks',
  'Projectors',
  'Network Switches',
  'AMC Services'
];

export const SERVICE_KEYWORDS = [
  { label: 'Installation', path: '/services-support/installation' },
  { label: 'AMC', path: '/services-support/amc' },
  { label: 'CCTV Installation & AMC', path: '/services-support/cctv-installation-amc' },
  { label: 'Audio-Video Solutions', path: '/services-support/audio-video-solutions' },
  { label: 'Home Automation Solutions', path: '/services-support/home-automation-solutions' }
];
